import { DatePicker, DatePickerProps } from 'antd';
import { ReactComponent as DatePick } from '@assets/image/iqsIcon/Date.svg';
import './index.scss';

const ZeissDatePicker = (props: DatePickerProps): any => {
  return (
    <DatePicker
      className="zeiss-reset-datePicker"
      style={{ width: '100%' }}
      // suffixIcon={<img src={datePicker} width={14} />}
      suffixIcon={<DatePick />}
      {...props}
    />
  );
};

export default ZeissDatePicker;
